import React from 'react';
export const LoadingImg = () => {
  return (
    <div className='loadingimg'>
      <img style={{ height: 70 }} src='/spinner.svg' />
    </div>
  );
};
